import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

import { Log } from '../../../utils/index';
import { TrackerAdmin, Tracker, BreadcrumbItem, TrackerStatus } from '../../../entities/index';
import { ActivationService } from '../../../services/activation.service';
import { TrackerAdminService } from '../../../services/trackeradmin.service';
import { TrackerStatusService } from '../../../services/trackerstatus.service';
import { TrackerService } from '../../../services/tracker.service';
import { RetailerService } from '../../../services/retailer.service';
import { TRACKER_FIRMWARES, TRACKER_TYPES } from '../../../services/constants.service';
import { RetailerShort } from '../../../entities/retailer.entity';

@Component({
  selector: 'app-trackeradmin-detail',
  templateUrl: './trackeradmin-detail.html'
})
export class TrackeradminDetailComponent implements OnInit {
  trackerId: number;
  trackerAdmin: TrackerAdmin = new TrackerAdmin();
  tracker: Tracker = new Tracker();

  trackerStatus: Promise<TrackerStatus[]>;
  retailers: Promise<RetailerShort[]>;

  firmwares: string[] = TRACKER_FIRMWARES;
  types: string[] = TRACKER_TYPES;

  pageTitle = 'Trackeradmin Detail';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('Trackeradmin List', 'map-marker', '/trackeradmin'),
    new BreadcrumbItem('Trackeradmin Detail', 'map-marker')
  ];

  constructor(protected route: ActivatedRoute,
              protected trackerStatusService: TrackerStatusService,
              protected trackerAdminService: TrackerAdminService,
              protected trackerService: TrackerService,
              protected retailerService: RetailerService,
              protected activationService: ActivationService,
              protected notification: NotificationsService) {
    this.trackerId = Number(route.snapshot.params.id);
    this.pageTitle += ' #' + this.trackerId;
    this.breadcrumbs[1].title = this.pageTitle;
  }

  @Log()
  ngOnInit() {
    this.trackerStatus = this.trackerStatusService.getAll();
    this.trackerAdminService
      .get(this.trackerId)
      .subscribe(tracker => {
        this.trackerAdmin = tracker;
        this._loadTracker(this.trackerAdmin);
      });
      this.retailers = this.retailerService.getAll();
    }

  @Log('blue')
  save() {
    this.trackerAdminService
      .save(this.trackerAdmin)
      .subscribe(tracker => {
        this.trackerAdmin = tracker;
        this.notification.success('SUCCESS', 'The trackerAdmin has been updated.');
      });
  }

  @Log('blue')
  suspendSIM() {
    this.activationService.deactivate(this.trackerAdmin.sim).subscribe(() => {
      this.notification.success('SUCCESS', 'The deactivation has been scheduled in a few minutes.');
    })
  }

  protected _handleProtectedFields(tracker: Tracker, trackerAdmin: TrackerAdmin) {
    tracker.lot = trackerAdmin.lot;
    tracker.model = trackerAdmin.model;
    tracker.tracker_color = trackerAdmin.tracker_color;
    return tracker;
  }

  protected _loadTracker(trackerAdmin: TrackerAdmin) {
    this.trackerService
      .findOneByTrackerAdmin(trackerAdmin)
      .subscribe(tracker => this.tracker = this._handleProtectedFields(tracker, trackerAdmin));
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/trackeradmin/trackeradmin-detail.component.ts